import React from 'react';

const IconlyCurvedBoldSwap = ({ width = 24, height = 25, fill = "#F04F4F" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.004 8.278c-.409-.773-2.572-4.633-4.963-4.633-2.39 0-4.555 3.86-4.964 4.633a1.001 1.001 0 0 0 1.768.936C4.435 8.102 5.3 6.917 6.041 6.23v11.033a1 1 0 1 0 2 0V6.23c.742.687 1.606 1.87 2.195 2.983a1.003 1.003 0 0 0 1.352.416c.488-.26.674-.864.416-1.352Zm9.505 6.213a1.001 1.001 0 0 0-1.352.414c-.588 1.11-1.448 2.292-2.186 2.98V6.854a1 1 0 1 0-2 0v11.033c-.742-.686-1.606-1.87-2.196-2.983a1 1 0 0 0-1.768.937c.409.773 2.572 4.631 4.964 4.631 2.382 0 4.545-3.858 4.954-4.63a1 1 0 0 0-.416-1.352Z"
    />
  </svg>
);

export default IconlyCurvedBoldSwap;